export default class FormRule {
    constructor(manager, settings = {}) {
        this.manager = manager;
        this.message = manager.getMessage(settings.message || this.getRuleName());
    }

    getRuleName() {
        return 'custom-rule';
    }

    getFormID() {
        return this.manager.getFormID();
    }

    getForm() {
        return this.manager.getForm() || document;
    }

    getMessage() {
        return this.message || 'invalid';
    }

    getElements() {
        return Array.from(this.getForm().elements);
    }
}
